<template>
  <div>
     
    <v-row
      class="pa-0">
      <v-col 
        cols="12"
        class="py-0 px-0">
        <v-card 
          flat
          class="pa-0">

          <v-card-text
            v-if="Object.keys(detail).length < 1" 
            class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <div class="mb-2 title">
                Mohon Tunggu...
              </div>
              <v-progress-circular
                indeterminate
                color="#00ADB5"></v-progress-circular>
            </div>
          </v-card-text>

          <v-card-text v-if="Object.keys(detail).length > 0">
            <!-- <div>
              <div>
                Status Approval
              </div>
              <div class="fs-16 label-input">
                {{ detail.status === 'proses' ? 'Proses' : detail.status === 'approved' ? 'Diterima' : 'Ditolak'}}
              </div>
            </div>
            <div class="" v-if="detail.status === 'rejected'">
              <div>
                Alasan
              </div>
              <div class="fs-16 label-input">
                {{ detail.rejected_reason }}
              </div>
            </div> -->
            <v-row>
              <v-col cols="6">
                <v-card
                  class="pa-0"
                  height="100%"
                  flat
                  style="border-radius: 12px; border: 1px solid rgba(238, 238, 238, 0.6); box-shadow: 0 4px 30px rgba(34, 40, 49, 0.06);">
                  <v-toolbar
                    color="#00ADB5"
                    dark>
                    <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                      Kunjungan NOO
                    </v-toolbar-title>

                    <v-spacer></v-spacer>


                  </v-toolbar>

                  <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                    General Manager
                  </v-card-text> -->

                  <v-card-text class="body-2 font-weight-light text-first">
                    <!-- <p class="mb-2">
                      <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                      <span v-if="item.start === item.end">
                        Tanggal <b>{{ item.date | date }}</b>
                      </span>
                    </p> -->

                    <div class="mb-2">
                      <div>
                        Target Kunjungan
                      </div>
                      <div class="font-weight-bold fs-22 mt-1 red--text">
                        {{ target.total_target_noo | number }}
                      </div>
                    </div>

                    <div class="mb-2">
                      <div>
                        Kunjunganyang telah Dilakukan
                      </div>
                      <div class="font-weight-bold fs-22 mt-1 green--text">
                        {{ target.total_actual_noo | number }}
                      </div>
                    </div>


                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="6">
                <v-card
                  class="pa-0"
                  height="100%"
                  flat
                  style="border-radius: 12px; border: 1px solid rgba(238, 238, 238, 0.6); box-shadow: 0 4px 30px rgba(34, 40, 49, 0.06);">
                  <v-toolbar
                    color="#00ADB5"
                    dark>
                    <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                      Kunjungan 
                    </v-toolbar-title>

                    <v-spacer></v-spacer>


                  </v-toolbar>

                  <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                    Supervisor
                  </v-card-text> -->

                  <v-card-text class="body-2 font-weight-light text-first">
                    <!-- <p class="mb-2">
                      <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                      <span v-if="item.start === item.end">
                        Tanggal <b>{{ item.date | date }}</b>
                      </span>
                    </p> -->

                    <div class="mb-2">
                      <div>
                        Target Kunjungan
                      </div>
                      <div class="font-weight-bold fs-22 mt-1 red--text">
                        {{ target.total_target_kunjungan | number }}
                      </div>
                    </div>

                    <div class="mb-2">
                      <div>
                        Kunjunganyang telah Dilakukan
                      </div>
                      <div class="font-weight-bold fs-22 mt-1 green--text">
                        {{ target.total_actual_kunjungan | number }}
                      </div>
                    </div>


                  </v-card-text>
                </v-card>
              </v-col>

            </v-row>

            <div v-if="message.error.length > 0"
              class="text-center my-4 d-flex align-center">
              <div
                class="error--text">
                <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      props: {
        detail: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
          
          zoomed: false,
          zoomedTtd: false,
          imageAspectRatio: 1,
          imageAspectRatioTtd: 1,
          target: {},

        
  
          process: {
            form: false,
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {

      },
      watch: {
        
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        this.fetchKunjungan()
      },
      methods: {
        async fetchKunjungan () {
          this.process.load = true

          let params = {
            sales_id: this.$route.params.id,
            // par_id: '1'
          }

          await get(`admin/target_visit/detail`, { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.target = res.results.data
              
            }
            this.process.load = false
          })
        },
        onImageLoad(e) {
          const img = e.target
          this.imageAspectRatio = img.naturalWidth / img.naturalHeight
        },
        onImageLoadAkta(e) {
          const img = e.target
          this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
        },
      }
    }
  </script>